// @flow

export function decideArgentineDocument(document: ?string): string {
  if (!document) {
    return '';
  }

  if (document.length === 11) {
    return 'CUIL';
  }

  return 'DNI';
}
